<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['class_mgt'] == 1">
      <div class="col-12">
        <div class="card shadow-lg">
          <div class="card-body">
            <div class="mb-2 float-end">
              <b-button v-b-modal.new-optionalfee size="sm" variant="primary"
                ><i class="mdi mdi-plus"></i> New Optional Fee Type</b-button
              >
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show
                    <b-form-select
                      class="form-select form-select-sm mx-1"
                      v-model="perPage"
                      size="sm"
                      :options="Options"
                    ></b-form-select>
                    entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
                <template #table-busy
                  ><div class="text-center text-primary my-2">
                    <b-spinner
                      class="align-middle"
                      type="grow"
                      small
                    ></b-spinner>
                    <strong>No Data Found</strong>
                  </div></template
                >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(actions)="data">
                  <div class="btn-group">
                    <b-button
                      @click="
                        edit(
                          data.item.id,
                          data.item.name,
                          data.item.amount,
                          data.item.description,
                          data.item.amount,
                        )
                      "
                      type="button"
                      class="btn-sm btn"
                      variant="primary"
                      v-b-modal.edit
                    >
                      <i class="mdi mdi-square-edit-outline"></i>
                    </b-button>
                    <b-button
                      @click="remove(data.item.id, data.item.name)"
                      type="button"
                      class="btn-sm btn"
                      variant="danger"
                      v-b-modal.delete
                    >
                      <i class="mdi mdi-trash-can"></i>
                    </b-button>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="List"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        id="new-optionalfee"
        centered
        title="New Optional Fee Types"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="addFeesCategory">
          <div class="form-group mb-2">
            <label>Name</label>
            <input v-model="name" type="text" class="form-control" />
          </div>
          <div class="form-group mb-2">
            <label>Amount</label>
            <input v-model="amount" type="number" class="form-control" />
          </div>
          <div class="form-group mb-2">
            <label>Description</label>
            <b-textarea
              v-model="description"
              type="number"
              class="form-control"
            />
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('new-optionalfee')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="edit-optionalfee"
        centered
        title="Edit Optional Fee Types"
        title-class="font-14"
        hide-footer
      >
        <form @submit.prevent="editFeesCategory">
          <div class="form-group mb-2">
            <input v-model="id" type="hidden" />
            <label>Name</label>
            <input v-model="name" type="text" class="form-control" />
          </div>
          <div class="form-group mb-2">
            <label>Amount</label>
            <input v-model="amount" type="number" class="form-control" />
          </div>
          <div class="form-group mb-2">
            <label>Description</label>
            <b-textarea
              v-model="description"
              type="number"
              class="form-control"
            />
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('edit-optionalfee')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="delete-optionalfee"
        centered
        title="Delete Optional Fees"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="removeFeesCategory">
          <input v-model="id" type="hidden" />
          Are you sure you want to delete the Optional Fees :
          <b>{{ name }}</b> ?
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('delete-optionalfee')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> YES</b-button
            >
          </div>
        </form>
      </b-modal>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { optionalfeeComputed, optionalfeeMethods } from "@/state/helpers";
import axios from "axios";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "Optional Fee Types",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Optional Fee Types",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Optional Fee Types", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "name", label: "Name", visible: true },
        { key: "description", label: "Description", visible: true },
        { key: "amount", label: "Amount", visible: true },
        { key: "created_at", label: "Created At", visible: true },
        { key: "actions", label: "Actions", visible: true },
      ],
      userData: JSON.parse(localStorage.getItem("user")),
      id: "",
      name: "",
      amount: "",
      description: "",
    };
  },
  computed: {
    ...optionalfeeComputed,
    List() {
      return this.optionalfees.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.optionalfees.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.optionalfees.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
  },
  mounted() {
    this.fetchOptionalFees();
    this.TotalRows = this.optionalfees.length;
    this.isBusy = false;
  },
  methods: {
    ...optionalfeeMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id, name, amount, description) {
      this.id = id;
      this.name = name;
      this.description = description;
      this.amount = amount;
      this.$bvModal.show("edit-optionalfee");
    },
    remove(id, name) {
      this.id = id;
      this.name = name;
      this.$bvModal.show("delete-optionalfee");
    },
    async addFeesCategory() {
      let formData = new FormData();
      formData.append("name", this.name);
      formData.append("amount", this.amount);
      formData.append("description", this.description);
      let url = "/addoptionalfee";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchOptionalFees();
          this.$bvModal.hide("new-optionalfee");
          this.name = "";
          this.description = "";
          this.amount = "";
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async editFeesCategory() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("name", this.name);
      formData.append("description", this.description);
      formData.append("amount", this.amount);
      let url = "/updateoptionalfee";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchOptionalFees();
          this.$bvModal.hide("edit-optionalfee");
          this.name = "";
          this.description = "";
          //this.amount="";
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async removeFeesCategory() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removeoptionalfee";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchOptionalFees();
          this.$bvModal.hide("delete-optionalfee");
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
  },
};
</script>
